"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useStorageRef;

var _react = require("react");

var _firebaseHooks = require("@rainbow-modules/firebase-hooks");

function useStorageRef(props) {
  var _ref = props || {},
      bucket = _ref.bucket;

  var app = (0, _firebaseHooks.useFirebaseApp)();
  return (0, _react.useMemo)(function () {
    return app.storage(bucket).ref();
  }, [app, bucket]);
}